<template>
	<a @click.prevent="openBookingEngine({ ...$props })">
		<slot />
	</a>
</template>

<script setup>
import { BookingEngineFactory } from '@becurioushq/mews';

const { locale } = useI18n();
const config = useRuntimeConfig();

const bookingEngine = useState('bookingEngine', () => {});

defineProps({
	language: { type: String, default: '' },
	arrival: { type: Date, default: null },
	departure: { type: Date, default: null },
	pax: { type: String, default: '' },
	packageid: { type: String, default: '' },
	roomid: { type: String, default: '' },
});

useHead({
	script: [
		{
			key: 'mews-distributor',
			src: 'https://api.mews.com/distributor/distributor.min.js',
		},
	],
});

const openBookingEngine = (options) => {
	if (!bookingEngine.value) {
		return;
	}

	if (!options.language) {
		options = { ...options, language: locale.value };
	}

	bookingEngine.value.visitUrl(options);
	// eslint-disable-next-line
	console.log('Booking Engine Options:', options);
};

onMounted(() => {
	if (!bookingEngine.value) {
		const factory = new BookingEngineFactory({
			hotelID: '516ca9a9-759a-4456-a6cb-b106006e5928',
			gtmID: config.public.googleTagManagerId,
			primaryColor: '#4d5728',
			mode: 'widget',
		});
		bookingEngine.value = factory.createBookingEngine();
	}
});
</script>

<style lang="scss" scoped>
a {
	color: #fff;
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
}
</style>
